export default __webpack_public_path__ + "static/media/dist.ac3cd01a.png";